'use client';
import React, { forwardRef } from 'react';
import SolidTab from './SolidTab.mjs';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

/**
 * 페이지 내 일부 영역에 사용하는 탭
 */
const SolidTabFlexibleSmall = /*#__PURE__*/forwardRef((props, ref) => {
  useApplyLogging('SolidTabFlexibleSmall');
  return /*#__PURE__*/React.createElement(SolidTab, {
    ...props,
    type: "small",
    typeLayout: "flexible",
    ref: ref
  });
});
SolidTabFlexibleSmall.displayName = 'SolidTabFlexibleSmall';

export { SolidTabFlexibleSmall as default };
